import React, { Component } from "react";
import { Select, Button, message, Table, Modal } from "antd";
import { getAllGames } from "@api/statistics";
import { search, download, billDetails } from "@api/gameBill";
import { formatDate } from "@utils/tool";

const Option = Select.Option;
const downloadjs = require("downloadjs");

class GameBill extends Component {
    state = {
        visible: false,
        selectedVal: {
            gameIds: ["allgame"],
            start: 0,
            end: 0
        },
        allSelect: [
            {
                key: "year",
                placeholder: "请选年份",
                options: [],
                title: "选择年份"
            },
            {
                key: "game",
                mode: "multiple",
                placeholder: "请选一级渠道",
                defaultValue: "allgame",
                options: [{ value: "allgame", label: "全部游戏" }],
                title: "选择游戏"
            }
        ],
        tableData: [],
        currtenMonth: "",
        currentTime: {},
        currentRowData: [],
        pagination: {
            pageSzie: 10,
            current: 1,
            total: 0
        },
        jsonAllGames: {}
    };

    handleSelectChange = (value, key) => {
        const tempVal = this.state.selectedVal;

        if (key === "year") {
            tempVal.start = value ? new Date(value, 0, 1, 0, 0, 0).getTime() / 1000 : 0;
            tempVal.end = value ? new Date(value + 1, 0, 1, 0, 0, 0).getTime() / 1000 : 0;
        }
        if (key === "game") {
            tempVal.gameIds = value.includes("allgame")
                ? Object.keys(this.state.jsonAllGames)
                : value;
        }

        this.setState({ selectedVal: tempVal });
    };

    getAllYears = () => {
        let tempOptions = [];
        const currentYear = new Date().getFullYear(),
            startYear = 2018;

        for (let i = startYear; i <= currentYear; i++) {
            tempOptions.push({ value: i, label: i });
        }

        this.setSelectOptions("year", tempOptions);
    };

    getAllGames = () => {
        getAllGames().then(res => {
            const games = res.data.data || [];
            let tempGameOptions = [{ value: "allgame", label: "全部游戏" }],
                jsonAllGames = {};

            games.forEach(item => {
                if (!jsonAllGames[item.gameId]) {
                    tempGameOptions.push({
                        value: item.gameId,
                        label: item.gameName || item.gameId
                    });
                    jsonAllGames[item.gameId] = item.gameName;
                }
            });

            this.setSelectOptions("game", tempGameOptions);
            this.setState({ jsonAllGames: jsonAllGames });
        });
    };

    setSelectOptions = (key, options = []) => {
        const tempAllSelect = this.state.allSelect;

        tempAllSelect.forEach(item => {
            if (item.key === key) {
                item.options = options;
            }
        });
        this.setState({ allSelect: tempAllSelect });
    };

    handleParamsVerification = () => {
        const isPass =
            this.state.selectedVal.gameIds.length === 0 ||
            this.state.selectedVal.start === 0;
        if (isPass) {
            message.error("时间, 游戏必填");
            return false;
        }
        return true;
    };

    handleSearch = () => {
        const result = this.handleParamsVerification();

        if (!result) return;

        this.searchData(this.state.selectedVal);
    };

    handleDownloadYearData = () => {
        const result = this.handleParamsVerification();

        if (!result) return;

        let params = this.state.selectedVal;

        Object.assign(params, {
            page: 1,
            size: this.state.pagination.total
        });

        download(params, false).then(res => {
            downloadjs(res.data);
        });
    };

    handleDownloadMonthData = () => {
        let params = this.state.selectedVal;

        Object.assign(params, {
            page: 1,
            size: this.state.pagination.total,
            start: this.state.currentTime.start,
            end: this.state.currentTime.end
        });

        download(params, true).then(res => {
            downloadjs(res.data);
        });
    };

    searchData = data => {
        if (data.gameIds.includes("allgame")) {
            data.gameIds = Object.keys(this.state.jsonAllGames);
        }

        const isAll = this.state.selectedVal.gameIds.includes("allgame") || (this.state.selectedVal.gameIds.length === Object.keys(this.state.jsonAllGames).length); 

        search(data).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            const list = res.data.data.list || [];
            const tempList = list.map(item => {
                if (isAll) {
                    Object.assign(item, { game: '全部' , gameIds: ['allgame'] })
                } else {
                    const gameId = this.state.selectedVal.gameIds;
                    const game = this.state.selectedVal.gameIds
                        .map(item => {
                            return this.state.jsonAllGames[item];
                        })
                        .join(", ");
                        
                    Object.assign(item, { game: game , gameIds: gameId })
                }
                return item;
            });

            this.setState({ tableData: tempList });
        });
    };

    changePage = page => {
        this.setState({ pagination: page }, () => {
            this.incomeBreakdownSearch(this.state.currentRowData);
        });
    };

    handleIncomeBreakdown = data => {
        const time = this.getMonthTime(data.timestamp);

        this.setState(
            {
                currentTime: time,
                currtenMonth: this.getCurrentTimeFormat(data.timestamp),
                visible: true,
                currentRowData: data
            },
            () => {
                this.incomeBreakdownSearch(data);
            }
        );
    };

    incomeBreakdownSearch = (data) => {
        let params = {
            ...this.state.currentTime,
            gameIds: data.gameIds.includes("allgame")
                ? Object.keys(this.state.jsonAllGames)
                : data.gameIds,
            page: this.state.pagination.current,
            size: 10
        };

        billDetails(params).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            const list = res.data.data.list || [];
            let tempPagination = this.state.pagination;

            tempPagination = {
                current: res.data.meta.paging.page,
                total: res.data.meta.paging.total,
                size: 10
            };
            this.setState({
                pagination: tempPagination,
                tableDetailData: list.map((item, index) => {
                    Object.assign(item, {
                        index: index,
                        game:
                            this.state.jsonAllGames[item.gameId] || item.gameId
                    });

                    return item;
                })
            });
        });
    };

    getMonthTime = data => {
        if (!data) return;

        let month = new Date(data * 1000).getMonth();
        let year = new Date(data * 1000).getFullYear();

        return {
            start: new Date(year, month, 1, 0, 0, 0).getTime() / 1000,
            end: new Date(year, month + 1, 1, 0, 0, 0).getTime() / 1000
        };
    };

    getCurrentTimeFormat = time => {
        return formatDate(time * 1000, "yyyy-MM");
    };

    handleModalCancle = () => {
        this.setState({ 
            visible: false,
            pagination: {
                pageSzie: 10,
                current: 1,
                total: 0
            } 
        });
    };

    componentDidMount() {
        this.getAllGames();
        this.getAllYears();
    }

    render() {
        const columns = [
            {
                title: "月份",
                dataIndex: "time",
                align: "center"
            },
            {
                title: "游戏",
                dataIndex: "game",
                align: "center",
                width: "200px"
            },
            {
                title: "总收益",
                dataIndex: "income",
                align: "center",
                render: (text, record) => (
                    <span>{Number(record.income).toFixed(2)}</span>
                )
            },
            {
                title: "总分成收益",
                dataIndex: "rltIncome",
                align: "center",
                render: (text, record) => (
                    <span>{Number(record.rltIncome).toFixed(2)}</span>
                )
            },
            {
                title: "操作",
                align: "center",
                render: (text, record) => (
                    <div>
                        <Button
                            type="primary"
                            onClick={() => {
                                this.handleIncomeBreakdown(record);
                            }}
                        >
                            收入明细
                        </Button>
                    </div>
                )
            }
        ];

        const detailColumns = [
            {
                title: "日期",
                dataIndex: "time",
                align: "center",
                width: "100px"
            },
            {
                title: "游戏",
                dataIndex: "game",
                align: "center",
                width: "100px"
            },
            {
                title: "总收益",
                dataIndex: "income",
                align: "center",
                width: "100px",
                render: (text, record) => (
                    <span>{Number(record.income).toFixed(2)}</span>
                )
            }
        ];

        return (
            <div>
                <h2 style={{ marginTop: 18 }}>游戏账单</h2>
                <ul style={{ overflow: "hidden", marginTop: 28 }}>
                    {this.state.allSelect.map(item => {
                        return (
                            <li
                                key={item.key}
                                style={{
                                    float: "left",
                                    width: 280,
                                    marginRight: 20
                                }}
                            >
                                <span style={{ lineHeight: "32px" }}>
                                    {item.title}
                                </span>
                                <Select
                                    optionFilterProp="children"
                                    allowClear={true}
                                    maxTagCount={1}
                                    mode={item.mode || ""}
                                    placeholder={item.placeholder}
                                    defaultValue={item.defaultValue}
                                    onChange={value => {
                                        this.handleSelectChange(
                                            value,
                                            item.key
                                        );
                                    }}
                                    style={{ width: "75%", float: "right" }}
                                    showSearch
                                >
                                    {item.options.map(ele => {
                                        return (
                                            <Option
                                                key={ele.value}
                                                value={ele.value}
                                            >
                                                {ele.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </li>
                        );
                    })}
                    <li
                        style={{
                            float: "left",
                            marginRight: 20
                        }}
                    >
                        <Button type="primary" onClick={this.handleSearch}>
                            查询
                        </Button>
                    </li>
                    <li
                        style={{
                            float: "right",
                            marginRight: 20
                        }}
                    >
                        <Button
                            type="primary"
                            onClick={() => {
                                this.handleDownloadYearData();
                            }}
                        >
                            下载
                        </Button>
                    </li>
                </ul>
                <Table
                    locale={{ emptyText: "暂无数据" }}
                    rowKey={item => item.time}
                    style={{ marginTop: 28 }}
                    columns={columns}
                    pagination={false}
                    dataSource={this.state.tableData}
                />
                <Modal
                    width="800px"
                    destroyOnClose={true}
                    footer={null}
                    title={`${this.state.currtenMonth} 游戏收入明细`}
                    visible={this.state.visible}
                    onCancel={this.handleModalCancle}
                    okText="确认"
                    cancelText="取消"
                >
                    <Button
                        type="primary"
                        onClick={() => {
                            this.handleDownloadMonthData();
                        }}
                    >
                        下载
                    </Button>
                    <Table
                        locale={{ emptyText: "暂无数据" }}
                        rowKey={item => item.index}
                        style={{ marginTop: 18 }}
                        // scroll={{ x: "100%", y: "210px" }}
                        columns={detailColumns}
                        pagination={this.state.pagination}
                        onChange={(page, pageSize) => {
                            this.changePage(page);
                        }}
                        dataSource={this.state.tableDetailData}
                    />
                </Modal>
            </div>
        );
    }
}

export default GameBill;
